export default __webpack_public_path__ + "static/media/fill-1.a76384f8.svg";